function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3Pfeil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51 51",
    width: 150,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "s3pfeil_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.31,39.94313a16.00045,16.00045,0,0,0,12.40674-.01074l-6.21631,7.626Z",
    style: {
      fill: "#941c81"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.28017,40.95107l-4.77915,5.863-4.761-5.85709a16.48961,16.48961,0,0,0,9.5401-.00595m3.20437-2.4426a15.51687,15.51687,0,0,1-15.93149.0188L25.5,48.30385l7.98453-9.79538Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3Pfeil);
export default __webpack_public_path__ + "static/media/s3pfeil.53b288658b4a57621ed9dcf6c0cc38a0.svg";
export { ForwardRef as ReactComponent };